// Page Me — the codebook. Only friendly, unambiguous codes (IDEATION MVP 7).

import { isEmoji, graphemes } from './text.js';

export const CODEBOOK = Object.freeze([
  { code: '143', meaning: 'I love you' },
  { code: '1432', meaning: 'I love you too' },
  { code: '459', meaning: 'I love you (keypad)' },
  { code: '831', meaning: 'I love you (8 letters, 3 words, 1 meaning)' },
  { code: '07734', meaning: 'Hello' },
  { code: '911', meaning: 'Urgent — call me' },
  { code: '411', meaning: "What's up? / info" },
  { code: '121', meaning: 'Need to talk' },
  { code: '222', meaning: "Let's eat" },
  { code: '100', meaning: 'Thinking of you' },
  { code: '4', meaning: 'For you' },
  { code: '88', meaning: 'Hugs & kisses' },
  { code: '50', meaning: 'Where are you?' },
  { code: '555', meaning: 'Call me when you can' },
  { code: '007', meaning: 'Secret' },
  { code: '10-4', meaning: 'Got it' },
]);

// Longest first, so "1432" is not read as "143" and "07734" not as "0…".
const BY_LENGTH = [...CODEBOOK].sort((a, b) => b.code.length - a.code.length);

/** The codebook entry a body starts with, or null. */
export function codeFor(body) {
  const s = String(body ?? '').trim();
  if (!s) return null;
  for (const entry of BY_LENGTH) {
    if (!s.startsWith(entry.code)) continue;
    const rest = s.slice(entry.code.length);
    if (!rest) return entry;
    // A code followed by a space or an emoji — "143 TO YOU TOO ❤️", "07734👋".
    if (/^\s/.test(rest)) return entry;
    const [first] = graphemes(rest);
    if (isEmoji(first)) return entry;
  }
  return null;
}

/** "143" → "I love you"; "07734 👋" → "Hello"; "1430" → null. */
export function hintFor(body) {
  return codeFor(body)?.meaning ?? null;
}
